import i18n from 'i18next';

import type {BulkOperationSelection} from '../../../types/BulkOperationActionCallback';
import type {BulkOperationPresentation} from '../../../types/BulkOperationPresentation';

/** Formats like `useFormatNumber` from `platform/locale`. */
type FormatNumber = (value: number, fractionDigits: number) => string | null;

export function getBulkOperationSelectionLabel(args: {
  selection: BulkOperationSelection;
  resourceId: string | undefined;
  formatNumber: FormatNumber;
  presentation?: BulkOperationPresentation;
}): string {
  if (args.selection.allFilteredSelected) {
    return `${i18n.t('page.datagrid.labels.filtered')}: ${args.formatNumber(args.selection.query.totalCount ?? 0, 0)} · ${i18n.t('general.labels.selected')}`;
  }
  const selectedLabel =
    args.resourceId === undefined
      ? undefined
      : args.presentation?.getSelectedLabel?.(args.resourceId, args.selection.recordIds.length);
  return (
    selectedLabel ??
    `${i18n.t('general.labels.selected')}: ${args.formatNumber(args.selection.recordIds.length, 0)}`
  );
}
